import dayjs from "@/libs/dayjs";
import { useSettingStore } from "@shared/stores";
import type { ParsedDateTime } from "@/pages/taskpane/features/resources/ulti";

// Format ParsedDateTime to YYYY-MM-DD (duplicate để tránh circular dependency)
const formatDate = (parsed: ParsedDateTime): string => {
    const day = String(parsed.day).padStart(2, "0");
    const month = String(parsed.month).padStart(2, "0");
    const year = parsed.year;
    return `${year}-${month}-${day}`;
};

export const useFormatDateTime = () => {
    const { dateSeparator, dateFormat, timeFormat } = useSettingStore();

    const formatDateWithLanguage = (date: string | Date | number | ParsedDateTime, format: string): string => {
        if (typeof date === "object" && "year" in date && "month" in date && "day" in date) {
          return dayjs(formatDate(date)).format(format);
        }
        return dayjs(date).format(format);
      };

    const handleFormatDateWithSeparator = (date: string | Date | number | ParsedDateTime): string => {
        const separator = dateSeparator || " ";
        const formatWithSeparator = dateFormat.replace(/-/g, separator);
        if (typeof date === "object" && "year" in date && "month" in date && "day" in date) {
            return dayjs(formatDate(date)).format(formatWithSeparator);
        }
        return dayjs(date).format(formatWithSeparator);
    }

    const handleFormatTimeWithLanguage = (time: string | Date | number | ParsedDateTime): string => {
        if (typeof time === "object" && "year" in time && "month" in time && "day" in time) {
            return dayjs(formatDate(time)).format(timeFormat);
        }
        return dayjs(time).format(timeFormat);
    }

    return { formatDateWithLanguage, handleFormatDateWithSeparator, handleFormatTimeWithLanguage };
};
